import React, { useState, useEffect } from 'react';
import { Text, theme } from '@dls/web';
import { Settings as SettingIcon } from '@dls/assets/icons';

import { Mock } from '../../features/mock/Mock';
import { Network } from '../../features/network/Network';
import { Logger } from '../../features/logger/Logger';
import { Products, PRODUCT } from '../../features/product/Products';
import mockIcon from '../../assets/mock.png';
import networkIcon from '../../assets/computer.png';
import loggerIcon from '../../assets/logger.png';
import { store } from '../../app/store';
import { MOCK_HOST } from '../../config/constants';

import { Panel } from '../Panel';
import { PanelMinimize } from '../PanelMinimize';

const ICON_STYLE = {
  width: '20px',
  height: '20px'
};

type FetchMockParam = {
  headers: {};
};

type ControlPanelPropsParam = {
  appName: string;
};

// @ts-ignore
export const ControlPanel = ({ appName }: ControlPanelPropsParam) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null);
  const { mock, network, logger } = store.getState();

  const fetchMock = async (
    url: string,
    params: FetchMockParam,
    baseHost: string,
    includeResponseHeaders: boolean
  ) => {
    url = url?.replace(baseHost, MOCK_HOST);
    params.headers = {
      'dt-app': appName,
      'dt-scenario': mock?.mock?.['scenario']?.value,
      'dt-scenario-group': mock?.mock?.['scenario-group']?.value
    };
    return fetch(url, params)
      .then((res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            const error = new Error(res.statusText);
            // @ts-ignore
            error.response = res;
            // @ts-ignore
            error.text = text;
            throw error;
          });
        }
        return res;
      })
      .then((res) => {
        return includeResponseHeaders ? res : res.json();
      })
      .catch((err) => {
        throw err;
      });
  };

  useEffect(() => {
    if (mock?.mock || network?.enabled || logger?.enabled) {
      window.mockEnabled = true;
      window.fetchMock = fetchMock;
    } else {
      window.mockEnabled = false;
      window.fetchMock = null;
    }
  }, [mock, network, logger]);

  const handleReset = () => {
    setProduct(null);
  };

  const renderProduct = () => {
    switch (product) {
      case PRODUCT.MOCK:
        return <Mock onClose={handleReset} appName={appName} />;
      case PRODUCT.NETWORK:
        return <Network />;
      case PRODUCT.LOGGER:
        return <Logger />;
    }
  };

  if (open) {
    return (
      <Panel
        isRootPage={!product}
        onClose={() => {
          setOpen(false);
          handleReset();
        }}
        onClear={handleReset}
      >
        {product ? (
          <>
            <Text type="bannerTitle">{product}</Text>
            {renderProduct()}
          </>
        ) : (
          <Products onSelect={setProduct} />
        )}
      </Panel>
    );
  }

  let panelMinimizeItems = [
    [
      {
        label: 'PANEL',
        icon: (
          <SettingIcon
            {...ICON_STYLE}
            color={theme.main.colours.tertiary.base}
          />
        )
      }
    ]
  ];

  let activePanelItems = [];

  if (mock?.mock) {
    activePanelItems.push({
      label: PRODUCT.MOCK,
      icon: <img src={mockIcon} {...ICON_STYLE} alt="mock logo" />,
      onClick() {
        setProduct(PRODUCT.MOCK);
      }
    });
  }
  if (network?.enabled) {
    activePanelItems.push({
      label: PRODUCT.NETWORK,
      icon: <img src={networkIcon} {...ICON_STYLE} alt="network logo" />,
      onClick() {
        setProduct(PRODUCT.NETWORK);
      }
    });
  }
  if (logger?.enabled) {
    activePanelItems.push({
      label: PRODUCT.LOGGER,
      icon: <img src={loggerIcon} {...ICON_STYLE} alt="mock logo" />,
      onClick() {
        setProduct(PRODUCT.LOGGER);
      }
    });
  }

  if (activePanelItems.length) {
    panelMinimizeItems.push(activePanelItems);
  }

  return (
    <PanelMinimize
      onClick={() => {
        setOpen(true);
        window.scrollTo(0, 0);
      }}
      items={panelMinimizeItems}
    />
  );
};
